export const DocumentLoading = ({className}) => {
  return (
    <svg
      className={className}
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.25"
        y="0.25"
        width="47.5"
        height="47.5"
        rx="23.75"
        fill="#F5F5F7"
      />
      <rect
        x="0.25"
        y="0.25"
        width="47.5"
        height="47.5"
        rx="23.75"
        stroke="#A5A5A5"
        strokeWidth="0.5"
      />
      <g clipPath="url(#clip0_1277_2876)">
        <path
          d="M30.75 33H17.25C17.0511 33 16.8603 32.921 16.7197 32.7803C16.579 32.6397 16.5 32.4489 16.5 32.25V15.75C16.5 15.5511 16.579 15.3603 16.7197 15.2197C16.8603 15.079 17.0511 15 17.25 15H26.25L31.5 20.25V32.25C31.5 32.4489 31.421 32.6397 31.2803 32.7803C31.1397 32.921 30.9489 33 30.75 33Z"
          stroke="#282828"
          strokeWidth="1.125"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M26.25 15V20.25H31.5"
          stroke="#282828"
          strokeWidth="1.125"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21 24.75H27"
          stroke="#282828"
          strokeWidth="1.125"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21 27.75H27"
          stroke="#282828"
          strokeWidth="1.125"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1277_2876">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(12 12)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
